import React, { Component } from 'react';

class ConfirmationBodyContainer extends Component {
    render() {
        return (
            <div className="confirmation__body">
                {this.props.children}
            </div>
        )
    }
}

export default ConfirmationBodyContainer;
